import { useMemo } from 'react';
import type { IntegrationExportSettingItem } from './types';

export const useSettingsConfiguredText = (
  config: IntegrationExportSettingItem
) => {
  return useMemo(() => {
    const configuredSettingsCount =
      Object.values(config).filter(Boolean).length;

    if (configuredSettingsCount === 0) {
      return null;
    }

    return `${configuredSettingsCount} Setting${
      configuredSettingsCount !== 1 ? 's' : ''
    } Configured`;
  }, [config]);
};

useSettingsConfiguredText.displayName = 'useSettingsConfiguredText';
